export default function CookiePolicyPage() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold mb-8">Cookie Policy</h1>
      <div className="prose prose-invert prose-gray max-w-none space-y-6 text-gray-300 leading-relaxed">
        <p className="text-sm text-gray-500">Last updated: March 2026</p>

        <section>
          <h2 className="text-xl font-semibold text-gray-50 mt-8 mb-3">What Are Cookies?</h2>
          <p>
            Cookies are small text files stored on your device when you visit a website.
            They are widely used to make websites work efficiently and to provide information
            to website owners.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-50 mt-8 mb-3">How We Use Cookies</h2>
          <p>Nokset uses only essential cookies that are strictly necessary for the Service to function:</p>

          <div className="bg-gray-900 border border-gray-800 rounded-lg p-4 mt-4">
            <h3 className="font-medium text-gray-50 mb-2">Authentication Cookies</h3>
            <ul className="list-disc pl-6 space-y-1 text-sm">
              <li><strong>Purpose:</strong> To keep you logged in and maintain your session</li>
              <li><strong>Duration:</strong> Expires when you log out or after your session expires</li>
              <li><strong>Type:</strong> Essential (required for the Service to work)</li>
            </ul>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-50 mt-8 mb-3">Third-Party Cookies</h2>
          <p>
            We do not use any third-party tracking, analytics, or advertising cookies.
            Your browsing activity on Nokset is not tracked by external parties through our Service.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-50 mt-8 mb-3">Managing Cookies</h2>
          <p>
            You can control and manage cookies through your browser settings. Please note that
            disabling essential cookies may prevent you from using certain features of the Service,
            such as logging in.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-50 mt-8 mb-3">Contact Us</h2>
          <p>
            If you have any questions about our use of cookies, please contact us at privacy@nokset.com.
          </p>
        </section>
      </div>
    </div>
  );
}
